import { CloseIcon, theme } from "ui";
import { buildTestIds } from "application";
import {
  ContainerModal,
  BoxModal,
  Description,
  BoxActions,
  ButtonSuccess,
  ButtonCancel,
  ButtonClose,
} from "./styles";

interface ModalVoltageProps {
  stateModal: boolean;
  actionCloseModal: () => void;
  actionSuccess: () => void;
  sendingItemToCart: boolean;
  infoText?: string;
}

const ModalVoltage = ({
  actionCloseModal,
  actionSuccess,
  stateModal = false,
  infoText,
  sendingItemToCart,
}: ModalVoltageProps) => {
  return (
    <ContainerModal {...buildTestIds("modal-voltage")} stateModal={stateModal}>
      <BoxModal {...buildTestIds("modal-voltage-box")}>
        <ButtonClose
          {...buildTestIds("modal-voltage-button-close")}
          isSendingItemToCart={sendingItemToCart}
          onClick={() => {
            if (!sendingItemToCart) {
              actionCloseModal();
            }
          }}
        >
          <CloseIcon
            alt="Fechar modal de voltagem"
            width={32}
            height={32}
            strokeWidth="0.8"
            color={theme.colors.primary["100"]}
          />
        </ButtonClose>
        <Description {...buildTestIds("modal-voltage-description")}>
          <h3 {...buildTestIds("modal-voltage-description-title")}>
            Voltagem escolhida:{" "}
            <span {...buildTestIds("info-text")}>{infoText}</span>
          </h3>
          <br />
          <span {...buildTestIds("modal-voltage-description-text")}>
            Tudo certo?
          </span>
        </Description>
        <BoxActions {...buildTestIds("modal-voltage-box-actions")}>
          <ButtonCancel
            {...buildTestIds("modal-voltage-button-cancel")}
            onClick={actionCloseModal}
            disabled={sendingItemToCart}
          >
            Voltar para o produto
          </ButtonCancel>
          <ButtonSuccess
            {...buildTestIds("modal-voltage-button-success")}
            onClick={actionSuccess}
            disabled={sendingItemToCart}
          >
            Sim, continuar
          </ButtonSuccess>
        </BoxActions>
      </BoxModal>
    </ContainerModal>
  );
};

export default ModalVoltage;
